// extracted by mini-css-extract-plugin
export var link = "AutoRenewal-module__link___YXNNL";